import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing/app-routing.module';
import { APIService } from './providers/api.service';
import { LocalStorageService, LocalStorageModule } from 'angular-2-local-storage';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import { ToastrModule } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { DragulaModule } from 'ng2-dragula';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatDialogModule } from '@angular/material/dialog';
import { LandingSuccessComponent } from './landing/landing-success/landing-success.component';
import { ContestSelectionComponent } from './landing/contest-selection/contest-selection.component';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { NflComponent } from 'src/app/welcome/nfl/nfl.component';
import { MlbComponent } from 'src/app/welcome/mlb/mlb.component';
import { NbaComponent } from 'src/app/welcome/nba/nba.component';
import { NhlComponent } from 'src/app/welcome/nhl/nhl.component';
import { UserIdleModule } from 'angular-user-idle';
import { NflProductComponent } from './welcome/nfl-product/nfl-product.component';
import { IDPGuysComponent } from './welcome/idpguys/idpguys.component';
import { OtpreceiveComponent } from './admin-dashboard/popup/otpreceive/otpreceive.component';
import { ReactiveFormsModule } from '@angular/forms';
import { OwlModule } from 'ngx-owl-carousel';
import { PhonePipeModule } from '../app/user-dashboard/phone/phone.module';
import { PhoneFormatPipe } from './phone-format.pipe';
import { EmailEditorModule } from 'angular-email-editor';
import { Meta } from '@angular/platform-browser';
import { SharedModule } from './shared-module/shared.module';



@NgModule({
  declarations: [
    AppComponent,
    LandingSuccessComponent,
    ContestSelectionComponent,
    NflComponent,
    MlbComponent,
    NbaComponent,
    NhlComponent,
    NflProductComponent,
    IDPGuysComponent,
    OtpreceiveComponent,
    PhoneFormatPipe,
    
    
  ],
 // entryComponents: [OtpreceiveComponent],
  imports: [
    AppRoutingModule,
    OwlModule,
    HttpClientModule,
    ReactiveFormsModule,
    LocalStorageModule.withConfig({
      storageType: 'localStorage'
    }),
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics]),
    BrowserAnimationsModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      timeOut: 1000
    }),
    CommonModule,
    DragulaModule,
    MatDialogModule,
    UiSwitchModule,
    EmailEditorModule,
    PhonePipeModule.forRoot(),
    UserIdleModule.forRoot({ idle: 259200, timeout: 1, ping: 10 }),
    // SharedModule declares the dialogs that ProSubscriptionValidationService
    // opens (AgeVerificationModalComponent, Under18ModalComponent). That
    // service is providedIn:'root', so its MatDialog resolves component
    // factories from the ROOT ComponentFactoryResolver — which, pre-Ivy, only
    // knows about eagerly-loaded modules. SharedModule was imported solely by
    // LAZY feature modules, so the root resolver had never seen those
    // entryComponents and the service threw "No component factory found for
    // AgeVerificationModalComponent" the moment it tried to open the DOB
    // overlay. Component-initiated opens (e.g. lobby.component) always worked,
    // because those live inside userdashboard.module's scope — which is why
    // this stayed hidden until the service path actually executed.
    SharedModule
  ],

  providers: [
    APIService,
    LocalStorageService,
    Meta
  ],

  bootstrap: [AppComponent],


})
export class AppModule { }



